import {
  FilterTypes,
  IFilter,
} from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import TagsFilter from "./filter-components/TagsFilter";
import ColorFilter from "./filter-components/ColorFilter";
import PriceRager from "./filter-components/PriceRager";
import SelectButtons from "./filter-components/SelectButtons";
import SelectOption from "./filter-components/SelectOption";
import { useIsMobile } from "@/hooks/useIsMobile";
import DropDownFilter from "./filter-components/DropDownFilter";

interface IFilterBuilder {
  filter: IFilter;
  state: any[];
  setState: (state: any[]) => void;
}
const FilterBuilder: React.FC<IFilterBuilder> = ({
  filter,
  state,
  setState,
}) => {
  const mobile = useIsMobile();
  switch (filter.configurations.type) {
    case FilterTypes.carousel:
      return mobile ? (
        <SelectButtons
          filter={filter}
          state={state}
          setState={setState}
          isFilterDrawer
        />
      ) : (
        <TagsFilter
          filter={filter}
          state={state}
          setState={setState}
          isFromFilters
        />
      );
    case FilterTypes.color_selector:
      return mobile ? (
        <ColorFilter
          filter={filter}
          state={state}
          setState={setState}
          isFilterDrawer
        />
      ) : (
        <TagsFilter
          isColor
          filter={filter}
          state={state}
          setState={setState}
          isFromFilters
        />
      );
    case FilterTypes.checkbox:
      return (
        <SelectOption
          filter={filter}
          state={state}
          setState={setState}
          isFromFilters
        />
      );
    case FilterTypes.dropdown:
      return (
        <DropDownFilter filter={filter} state={state} setState={setState} />
      );
    case FilterTypes.range_slider:
      return <PriceRager filter={filter} state={state} setState={setState} />;
    case FilterTypes.tags:
    case FilterTypes.images:
      return (
        <TagsFilter
          filter={filter}
          state={state}
          setState={setState}
          isFromFilters
        />
      );
    default:
      return null;
  }
};
export default FilterBuilder;
